module.exports = __webpack_public_path__ + "img/7.a2f7c94b.png";